import * as cookie from "cookie";

export function setCookie(name: string, value: string, days: number = 1): void {
    const now = new Date();
    const expires = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);

    const cookieString = cookie.serialize(name, value, {
        expires,
        path: "/",
        secure: true,
        sameSite: "strict",
    });
    document.cookie = cookieString;
}

export function getCookie(name: string): string | undefined {
    const cookies = cookie.parse(document.cookie);
    return cookies[name];
}

export function deleteCookie(name: string): void {
    const cookieString = cookie.serialize(name, "", {
        expires: new Date(0),
        path: "/",
        secure: true,
        sameSite: "strict",
    });
    document.cookie = cookieString;
}
